/**
 * Rounds a number to a specified number of decimal places, default is 2.
 */
export function roundToDecimalPlaces(number: number, decimalPlaces = 2): number {
    const factor = Math.pow(10, decimalPlaces)
    return Math.round(number * factor) / factor
}
